module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "myScore"
  }, [_c('div', {
    staticClass: "flex-row-bc"
  }, [_c('div', [_c('div', {
    staticClass: "fs-32 fw-bold flex-row-sc"
  }, [_vm._v("\n          我的蟠桃\n          "), _c('span', {
    staticClass: "detail",
    on: {
      "click": function($event) {
        return _vm.toScoreDetail()
      }
    }
  }, [_vm._v("明细")])]), _vm._v(" "), _c('div', {
    staticClass: "fw-bold",
    staticStyle: {
      "font-size": ".96rem",
      "padding": ".15rem 0"
    }
  }, [_vm._v(_vm._s(_vm.scoreInfo.score))])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "2rem",
      "margin-right": ".56rem"
    },
    attrs: {
      "src": _vm.scoreInfo.icon,
      "mode": "widthFix"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rules",
    on: {
      "click": function($event) {
        return _vm.toRules()
      }
    }
  }, [_vm._v("说明")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-tit"
  }, [_vm._v(_vm._s(_vm.userSignInfo.title))]), _vm._v(" "), _c('div', {
    staticClass: "sign-list flex-row-bc"
  }, _vm._l((_vm.userSignInfo.signList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item flex-colum-cc"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.toSign(item.is_today_sign)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), (item.is_today_sign === 0) ? _c('div', {
      staticClass: "tips",
      style: ({
        color: item.text_color
      })
    }, [_vm._v(_vm._s(item.tips))]) : _vm._e()])])
  }), 0)]), _vm._v(" "), (_vm.taskInfo.rookieTaskList) ? _c('div', {
    staticClass: "card"
  }, [(_vm.taskInfo.rookieTaskList.title) ? _c('div', {
    staticClass: "card-tit"
  }, [_vm._v("\n      " + _vm._s(_vm.taskInfo.rookieTaskList.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-list"
  }, _vm._l((_vm.taskInfo.rookieTaskList.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "score"
    }, [_vm._v("+" + _vm._s(item.score))])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [(item.complete_status == 3) ? _c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v(_vm._s(item.title) + "(仅限俺来也APP)")]) : _c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "fs-20 fc-666 marginT14"
    }, [_vm._v(_vm._s(item.des))])])]), _vm._v(" "), _c('div', {
      staticClass: "btns"
    }, [(item.complete_status == 1) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.makeScore(item)
        }
      }
    }, [_vm._v("做任务")]) : (item.complete_status == 2) ? _c('div', {
      staticClass: "btn completed"
    }, [_vm._v("已完成")]) : (item.complete_status == 3) ? _c('div', {
      staticClass: "btn"
    }, [_c('a', {
      staticStyle: {
        "color": "#2F2F2F"
      },
      attrs: {
        "href": "https://dl.anlaiye.com"
      }
    }, [_vm._v("下载APP")])]) : _vm._e()])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.taskInfo.dailyTaskList) ? _c('div', {
    staticClass: "card"
  }, [(_vm.taskInfo.dailyTaskList.title) ? _c('div', {
    staticClass: "card-tit"
  }, [_vm._v("\n      " + _vm._s(_vm.taskInfo.dailyTaskList.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-list"
  }, _vm._l((_vm.taskInfo.dailyTaskList.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "score"
    }, [_vm._v("+" + _vm._s(item.score))])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [(item.complete_status == 3) ? _c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v(_vm._s(item.title) + "(仅限俺来也APP)")]) : _c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "fs-20 fc-666 marginT14"
    }, [_vm._v(_vm._s(item.des))])])]), _vm._v(" "), _c('div', {
      staticClass: "btns"
    }, [(item.complete_status == 1) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.makeScore(item)
        }
      }
    }, [_vm._v("做任务")]) : (item.complete_status == 2) ? _c('div', {
      staticClass: "btn completed"
    }, [_vm._v("已完成")]) : (item.complete_status == 3) ? _c('div', {
      staticClass: "btn"
    }, [_c('a', {
      staticStyle: {
        "color": "#2F2F2F"
      },
      attrs: {
        "href": "https://dl.anlaiye.com"
      }
    }, [_vm._v("下载APP")])]) : _vm._e()])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showMask) ? _c('div', {
    staticClass: "mask-box",
    on: {
      "click": function($event) {
        _vm.showMask = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "ac fs-42"
  }, [_vm._v(_vm._s(_vm.signedInfo.msg))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.signedInfo.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "height": "1rem",
      "line-height": "1rem",
      "font-size": ".4rem",
      "font-weight": "bold",
      "border-radius": ".24rem",
      "padding": "0"
    }
  }, [_vm._v("开心收下")])])]) : _vm._e(), _vm._v(" "), (_vm.showMakeScore) ? _c('div', {
    staticClass: "mask-box",
    on: {
      "click": function($event) {
        _vm.showMakeScore = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('img', {
    staticClass: "mask-close",
    attrs: {
      "src": require("../assets/images/close-btn02.png")
    },
    on: {
      "click": function($event) {
        _vm.showMakeScore = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.makeScoreInfo.tips))]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showMakeScore = false
      }
    }
  }, [_vm._v("知道了")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1797d278","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/myScore.vue
// module id = 415
// module chunks = 7